import { createSelector } from '@ngrx/store';
import * as fromFeature from '../reducers';
import * as fromAudit from '../reducers/audit.reducer';

export const selectAudit = createSelector(
  fromFeature.getAuditItem,
  (state: any) => state.data
);

export const getModule = createSelector(
  selectAudit,
  fromAudit.getAudit
);

export const getCompanies = createSelector(
  selectAudit, 
  fromAudit.getCompanies
);

export const getAuthors = createSelector(
  selectAudit,
  fromAudit.getAuthors
);

export const getModuleLoaded = createSelector(
  selectAudit,
  fromAudit.getAuditLoaded
);

export const getModuleLoading = createSelector(
  selectAudit,
  fromAudit.getAuditLoading
);

export const getModuleDocuments = createSelector(
  selectAudit,
  fromAudit.getAuditDocuments
);

export const getInfos = createSelector(
  selectAudit,
  fromAudit.getInfos
);
